import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiDialog-paper': {
      height: '94vh',
      width: '90%',
    },
    '& .MuiDialogTitle-root': {
      backgroundColor: theme.palette.custom.main,
      color: '#fff',
      padding: '8px 20px',
    },
    '& .MuiDialogTitle-root+.MuiDialogContent-root ': {
      paddingTop: 20,
    },
    '& .MuiDialogContent-root': {
      padding: '20px 20px',
    },
    '& .MuiDialogActions-root': {
      paddingInlineEnd: 24,
    },
  },
  dialogTitleContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  title: {
    color: '#fff',
    fontWeight: '500',
  },
  closeIcon: {
    color: '#fff',
  },
  btnWrapper: {
    display: 'flex',
    gap: 20,
  },
  closeBtn: {
    '& .MuiButtonBase-root': {
      backgroundColor: '#e5e5e5',
      textTransform: 'capitalize',
      color: '#000',
      borderRadius: 20,
      padding: '6px 20px',
      '&:hover': {
        backgroundColor: '#e5e5e5',
      },
    },
  },
}))

export default useStyles
